import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'upsc-how-to-schedule-pickup-dialog',
    templateUrl: './how-to-schedule-pickup-dialog.component.html',
    styleUrls: ['./how-to-schedule-pickup-dialog.component.scss'],
})

export class HowToSchedulePickupDialogComponent implements OnInit {
    //#region Variables

    //#endregion

    //#region Methods
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit(): void {

    }
    //#endregion
}